import React, { CSSProperties } from 'react';
import {
  Box,
  Grid,
  GridProps,
  Typography,
  TypographyProps,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  ellipsis: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

type StylesKey = 'container' | 'text';

interface Props {
  ariaTitle?: string;
  bold?: boolean;
  color?: TypographyProps['color'];
  disableTextPadding?: boolean;
  icon: React.ReactNode;
  justifyContent?: GridProps['justifyContent'];
  styles?: Partial<Record<StylesKey, CSSProperties>>;
  text: React.ReactNode;
  variant?: TypographyProps['variant'];
}

const TextWithIcon: React.FC<Props> = (props: Props) => {
  const {
    ariaTitle = '',
    bold = false,
    color = 'textSecondary',
    disableTextPadding = false,
    icon,
    justifyContent,
    styles,
    text,
    variant = 'caption',
  } = props;

  const classes = useStyles();

  const pt = disableTextPadding ? 0 : 0.5;

  return (
    <Typography
      color={color}
      component="div"
      minWidth={0}
      style={styles?.container}
      title={ariaTitle}
      variant={variant}
    >
      <Grid
        alignItems="center"
        container
        justifyContent={justifyContent}
        wrap="nowrap"
      >
        {icon}
        <Box
          className={classes.ellipsis}
          component={bold ? 'strong' : 'span'}
          pl={1}
          pt={pt}
          style={styles?.text}
        >
          {text}
        </Box>
      </Grid>
    </Typography>
  );
};

export default TextWithIcon;
